<script>
  import BaseRemoteSelect from './base-remote-select';

  export default {
    extends: BaseRemoteSelect,

    computed: {
      /**
       * @return {object|null}
       */
      outgoingNumber() {
        return _.get(this.model, 'outgoing_number', null);
      },
    },

    methods: {
      /**
       * @param {Object} item
       * @return {string}
       */
      format(item) {
        return _.get(item, 'presentation', '');
      },
    },

    mounted() {
      if (this.brandId && this.outgoingNumber) {
        this.options = [{...this.outgoingNumber}];
        this.search('');
      }
    },
  }
</script>
